<mat-accordion>
  @for (tests of groupedTests(); track tests) {
  <mat-expansion-panel
    (opened)="panelOpenState = true"
    (closed)="panelOpenState = false"
    (click)="$event.stopPropagation()">
    <mat-expansion-panel-header>
      <mat-panel-title class="accordion-title">
        <div class="exam-summary">
          <div class="chip">
            <syn-status-avatar [examStatus]="tests.status" [border]="true" />
          </div>
          <div class="label">
            {{ tests.label }}
            @if (tests.duplicates[0].isCertifying) {
            <syn-certified-assessment-icon />
            }
          </div>
        </div>
        <div>
          @if (tests.duplicates.length > 1) {
          <div>tentatives : {{ tests.duplicates.length }}</div>
          } @else { tentative : {{ tests.duplicates.length }}
          }
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>
    @for (duplicate of tests.duplicates; track duplicate) {
    <div>
      <div class="exam-summary">
        <div class="chip">
          <syn-status-avatar [examStatus]="duplicate.examStatus" [border]="true" />
        </div>
        <div class="label">
          {{ duplicate.label }}
        </div>
        <div class="score">{{ duplicate.score }} / 100</div>
        @if (isExamStatusDone(duplicate.examStatus)) {
        <div class="time-spent justify-content-between p-2">
          <span class="icon material-symbols-outlined"> hourglass_bottom </span>
          {{ duplicate.timeSpent | chrono : true }}
        </div>
        }
      </div>
    </div>
    }
  </mat-expansion-panel>
  }
</mat-accordion>
